import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20abstract%20sports%20atmosphere%20with%20flowing%20orange%20and%20dark%20gradients%2C%20motion%20blur%20effects%2C%20energetic%20sports%20texture%2C%20modern%20abstract%20design%20with%20dynamic%20lines%2C%20warm%20color%20palette&width=1200&height=600&seq=cta-bg-sports&orientation=landscape"
              alt="加入开云体育"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/60"></div>
          </div>

          <div className="relative z-10 text-center py-12 md:py-16 px-6 md:px-10">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3">
              {t('cta_title')}
            </h2>
            <p className="text-background-50/75 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
              {t('cta_subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/football"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 hover:bg-primary-600 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                {t('cta_button')}
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 border-2 border-background-50/40 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 hover:bg-background-50/10 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}